import React from "react";

const NotFound = () => {
  return (
    <div className="not-found">
      <h1>Opps! We can't find the page you're looking for.</h1>
    </div>
  );
};

export default NotFound;
